import React, {useEffect, useState} from "react";
import {connect} from "react-redux";


function ItemCartProductInfo({product, key}) {
    const [variants, setVariant] = useState([]);

    useEffect(() => {
        if (product) {
            let variantId = product.variant_id;
            let variantObject = product.variants.find(v => v.id === variantId);
            setVariant(variantObject.values);
        }
    }, [product]);

    const unitPrice = product.has_offer ? product.offer_price : product.price;
    const totalPrice = product.quantity * unitPrice;

    return (
        <div
            className="flex flex-col sm:flex-row sm:items-center bg-white border border-gray-100 p-4 md:p-5 rounded-xl gap-4 transition-all duration-300"
            key={key}
        >
            {/* Product Image */}
            <div className="relative flex-shrink-0">
                <div className="w-20 h-20 md:w-24 md:h-24 rounded-xl overflow-hidden bg-gray-50 border border-gray-100">
                    <img
                        src={product.first_image}
                        alt={product.name}
                        className="w-full h-full object-cover"
                    />
                </div>
                {/* Quantity badge */}
                <div className="absolute -top-2 -right-2 w-7 h-7 bg-ecoprimary1 text-white rounded-full flex items-center justify-center text-xs font-bold shadow-sm">
                    {product.quantity}
                </div>
            </div>

            {/* Product Info */}
            <div className="flex-1 flex flex-col gap-2 min-w-0">
                {/* Name + Total Price */}
                <div className="flex flex-col sm:flex-row sm:justify-between sm:items-start gap-1">
                    <div className="min-w-0 flex-1">
                        <h3 className="font-bold text-base text-gray-800 truncate">
                            {product.name}
                        </h3>
                        <div className="flex items-center gap-2 mt-1">
                            {product.has_offer ? (
                                <>
                                    <span className="text-xs line-through text-red-300">
                                        Bs {product.previous_price}
                                    </span>
                                    <span className="text-sm font-bold text-green-600 bg-green-50 px-2 py-0.5 rounded-full">
                                        Bs {product.offer_price}
                                    </span>
                                </>
                            ) : (
                                <span className="text-sm font-semibold text-gray-500">
                                    Bs {product.price}
                                </span>
                            )}
                            <span className="text-xs text-gray-400">× {product.quantity}</span>
                        </div>
                    </div>
                    <div className="text-right sm:ml-4 flex-shrink-0">
                        <span className="text-lg font-bold text-gray-900">
                            Bs {totalPrice.toFixed(2)}
                        </span>
                    </div>
                </div>

                {/* Variant Badges */}
                <div className="flex flex-wrap gap-1.5">
                    {variants.map((value, idx) => (
                        <span
                            key={idx}
                            className="inline-flex items-center bg-blue-50 text-ecoprimary1 text-xs font-medium px-2.5 py-1 rounded-full"
                        >
                            {value.attribute}: {value.value}
                        </span>
                    ))}
                </div>
            </div>
        </div>
    );
}

// Conectamos el componente a Redux
export default connect(null, {})(ItemCartProductInfo);
